import type { ApplicationPermission as ApplicationPermissionModel } from '@/adapters/catalogv1.g';

export function extractApplicationPermission(
  model: ApplicationPermissionModel
) {
  return {
    id: model._metadata?.distinct_id ?? '',
    applicationRef: model.application_ref ?? '',
    permissionRef: model.permission_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogApplicationPermission = ReturnType<
  typeof extractApplicationPermission
>;
